export type UploadEntityType =
  | 'JobMedia'
  | 'JobIncidentMedia'
  | 'JobRestorationMedia'
  | 'RepairTicketPicture';

const ENTITY_PATHS: Record<UploadEntityType, string> = {
  JobMedia: 'jobs/media',
  JobIncidentMedia: 'jobs/incidents/media',
  JobRestorationMedia: 'jobs/restoration/media',
  RepairTicketPicture: 'equipment/repair-tickets/pictures',
};

export interface UploadUrls {
  refreshUrl: string;
  completeUrl: string;
}

/**
 * The plugin builds its own requests natively, so it needs absolute URLs.
 * apiUrl comes from ApiService.url, which already appends /api/v1.
 */
export function uploadUrlsFor(
  apiUrl: string,
  entityType: UploadEntityType,
  id: string
): UploadUrls {
  const path = ENTITY_PATHS[entityType];
  return {
    refreshUrl: `${apiUrl}/${path}/${id}/upload-url`,
    completeUrl: `${apiUrl}/${path}/${id}/complete`,
  };
}

export function detailUrlFor(
  apiUrl: string,
  entityType: UploadEntityType,
  id: string
): string {
  return `${apiUrl}/${ENTITY_PATHS[entityType]}/${id}`;
}
